import React, { useRef, useState } from 'react';
import styles from '../styles.module.scss';

const Index = ({ Component, list, divisionWidth = 200 }) => {
  const [activeCount, setActiveCount] = useState(1);
  const carousalRef = useRef<any>(null);

  const handleScroll = () => {
    if (carousalRef?.current?.scrollLeft) {
      const count = Math?.floor(
        carousalRef?.current?.scrollLeft / divisionWidth
      );
      if (count >= 0) setActiveCount(count + 1);
      else setActiveCount(1);
    } else setActiveCount(1);
  };

  return (
    <section className={styles.staticCarousal}>
      <div
        className={styles.carousalContainer}
        ref={carousalRef}
        onScroll={() => handleScroll()}
      >
        {list?.map((carousalItem, i) => (
          <div key={i} className={styles.carousalItem}>
            <Component carousalItem={carousalItem} />
          </div>
        ))}
      </div>
      <div className={styles.tracker}>
        {list.map((_, i) => (
          <div
            key={_?.name}
            className={`${styles.trackerDot} ${
              activeCount === i + 1 ? styles.activeDot : ''
            }`}
          />
        ))}
      </div>
    </section>
  );
};

export default Index;
